/** @jsxImportSource @emotion/react */
import React from 'react'

import Input from './Input'

const XNumberInput = ({ min, max, onlyInt, onChange, ...props }) => {
  const handleChange = value => {
    const replaceValue = () => {
      if (max !== undefined && value > max) return max
      if (min !== undefined && value < min) return min
      if (value != '-' && value != '0' && value !== undefined && onlyInt) return parseInt(value)
      return value
    }

    if (onChange) onChange(replaceValue())
  }

  return <Input onChange={handleChange} type="number" {...props} />
}

export default XNumberInput
